export default __webpack_public_path__ + "static/mika-16f414cd44722e497175fa81fa3389bc.svg";